import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { GroupsOfGroupStoreSelectors, UserGroupAclStoreActions, UserGroupAclStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { UserGroupAclGroups } from '@rocksoft/security-sdk';
import { AclPermissionDetailsComponent, isNotUndefined, NamedUserGroupAclGroups } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'era-group-acl-permissions-details',
  templateUrl: './group-acl-permissions-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AclPermissionDetailsComponent, AsyncPipe],
})
export class GroupAclPermissionsDetailsComponent {
  private readonly store = inject(Store);

  public readonly acl$: Observable<UserGroupAclGroups>;
  public readonly aclParents$: Observable<NamedUserGroupAclGroups[]>;

  constructor() {
    this.acl$ = this.store.select(UserGroupAclStoreSelectors.selectCurrentAclGroup).pipe(filter(isNotUndefined));

    this.aclParents$ = this.acl$.pipe(
      mergeMap((locationAclGroup) =>
        this.store.select(GroupsOfGroupStoreSelectors.selectParentGroupIds(locationAclGroup.groupId)).pipe(
          mergeMap((groupIds: string[]) =>
            this.store.select(UserGroupAclStoreSelectors.selectCurrentAclGroupsWithNamesByGroupIds(groupIds)).pipe(
              filter(isNotUndefined),
              map((groups) => groups.map((g) => ({ ...g, name: g.name ?? '' })))
            )
          )
        )
      )
    );
  }

  public submitFormEvent(userGroupAclGroups: UserGroupAclGroups) {
    this.store.dispatch(
      UserGroupAclStoreActions.GroupAclPermissionsUiActions.userGroupAclGroupPut({ aclGroup: userGroupAclGroups })
    );
  }
}
